<template>
  <div class="predicted-transaction-container" :class="{ selected: isSelected && canEditEnvelope }">
    <div @click="canEditEnvelope && toggleActions()">
      <predicted-transaction-row :predicted-transaction="predictedTransaction" :can-edit-envelope="canEditEnvelope"
                                                  :category-name="categoryName" :isSelected="isSelected" />
    </div>
    <collapse-transition>
      <actions :actions="actions" :category-name="categoryName" v-show="isSelected && canEditEnvelope" />
    </collapse-transition>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
// eslint-disable-next-line max-len
import ChangeTransactionCategoryPopup from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/ChangeTransactionCategoryPopup';
import CollapseTransition from '../../../../../../../../../base-components/CollapseTransition.vue';
import PredictedTransactionRow from './PredictedTransactionRow.vue';
import Actions from '../../../../../../../../../base-components/Actions.vue';
import Segment from '../../../../../../../../../Segment';
import EditPredictedWithActualFlow
  from '../../../current-month/components/cashflow-edit/edit-transaction/edit-predicted-transaction/flows/EditPredictedWithActualFlow.vue';
import EditPredictedWOActualFlow
  from '../../../current-month/components/cashflow-edit/edit-transaction/edit-predicted-transaction/flows/EditPredictedWOActualFlow.vue';
import EditPredictedIncomeWOActualFlow
  from '../../../current-month/components/cashflow-edit/edit-transaction/edit-predicted-transaction/flows/EditPredictedIncomeWOActualFlow.vue';

import ModalBus from '../../../../../../../../../event-bus/modal-bus';

export default {
  name: 'PredictedTransaction',
  props: [
    'predictedTransaction',
    'canEditCategory',
    'showPrediction',
    'categoryName',
  ],
  components: {
    PredictedTransactionRow,
    CollapseTransition,
    Actions,
  },
  computed: {
    ...mapState('cashflowView', ['actionsExpandedFor']),
    canEditEnvelope() {
      return this.actions.length > 0 && this.canEditCategory;
    },
    hasActual() {
      return this.predictedTransaction.actual;
    },
    isIncome() {
      return this.predictedTransaction.isIncome;
    },
    incomeOrExpense() {
      return this.isIncome ? 'הכנסה' : 'הוצאה';
    },
    isSelected() {
      return this.actionsExpandedFor === this.predictedTransaction.envelopeId;
    },
    actionsMapping() {
      return {
        editCategory: {
          text: `להעביר את ה${this.incomeOrExpense} למקום אחר `,
          icon: 'edits-move',
          onClick: this.openEditCategory,
        },
        cancelEnvelope: {
          icon: 'edits-trash',
          onClick: this.openEditPredictedTransaction(EditPredictedIncomeWOActualFlow),
          text: 'מחיקת צפי הכנסה',
        },
        changeCategoryWithActual: {
          icon: 'edits-sub-category',
          onClick: this.openEditPredictedTransaction(EditPredictedWithActualFlow),
          text: 'לשנות את סוג ההוצאה',
        },
        changeCategoryWOActual: {
          icon: 'edits-sub-category',
          onClick: this.openEditPredictedTransaction(EditPredictedWOActualFlow),
          text: 'לשנות את סוג ההוצאה',
        },
      };
    },
    actions() {
      return actionsPredicates(this.actionsMapping)
        .flatMap(predicate => predicate(this.hasActual, this.isIncome));
    },
  },
  methods: {
    ...mapActions('editTransaction', ['startEditingTransaction']),
    ...mapActions('cashflowView', ['expandActionsOf']),
    openEditPredictedTransaction(popupToOpen) {
      return () => {
        Segment.trackUserInteraction('EditPredictedTransactionClicked', { businessName: this.predictedTransaction.name });
        ModalBus.$emit('open', {
          component: popupToOpen,
          props: {
            predictedTransaction: this.predictedTransaction,
          },
        });
      };
    },
    openEditCategory() {
      Segment.trackUserInteraction('EditTransactionClicked', { businessName: this.predictedTransaction.businessName });
      this.startEditingTransaction({
        transaction: this.predictedTransaction.actual,
        categoryName: this.categoryName,
        categoryId: this.categoryId,
      });
      ModalBus.$emit('open', {
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
    toggleActions() {
      if (this.isSelected) {
        this.expandActionsOf(null);
      } else {
        this.expandActionsOf(this.predictedTransaction.envelopeId);
      }
    },
  },
};

const actionsPredicates = actionsMapping => [
  (hasActual, isIncome) => (hasActual ? actionsMapping.editCategory : []),
  (hasActual, isIncome) => (isIncome && !hasActual ? actionsMapping.cancelEnvelope : []),
  (hasActual, isIncome) => (!isIncome && hasActual ? actionsMapping.changeCategoryWithActual : []),
  (hasActual, isIncome) => (!isIncome && !hasActual ? actionsMapping.changeCategoryWOActual : []),
];

</script>

<style scoped lang="scss">
    @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .predicted-transaction-container {
    transition: background-color 0.3s;
    background-color: $riseup_gray_0;
    &.selected {
      background-color: $riseup_v2_light_grey;
    }
    border-bottom: 1px solid $riseup_white;
    &:first-of-type {
      box-shadow: inset 0 2px 3px 0 rgba(155, 155, 155, 0.51);
    }
    &:last-of-type {
      border-bottom: none;
    }
  }
</style>
